import React from 'react';
import { TableCell, TableRow } from '@mui/material';

import {
  formatDeflectionLoading,
  isVerticalMaxDeflectionEntry,
  MaxDeflectionEntry,
  MaxDeflectionTable,
} from '@paragon/contract-library';

import { PropertyTable } from './PropertyTable';

const MaxDeflectionEntryRow = ({ value }: { value: MaxDeflectionEntry | null }) =>
  value ? (
    <TableRow>
      <TableCell>{formatDeflectionLoading(value.loading)}</TableCell>
      <TableCell>{value.direction}</TableCell>
      <TableCell>{value.location}</TableCell>
      <TableCell>{value.greatestDeflection.toFixed(3)}</TableCell>
      <TableCell>
        {isVerticalMaxDeflectionEntry(value)
          ? value.deflectionRatio == null || value.deflectionRatio > 999
            ? '>999'
            : value.deflectionRatio.toFixed(0)
          : ''}
      </TableCell>
      <TableCell>{isVerticalMaxDeflectionEntry(value) ? value.deflectionLimit.toFixed(0) : ''}</TableCell>
    </TableRow>
  ) : null;

interface Props {
  value: MaxDeflectionTable;
  paperElevation?: number;
}

export function MaxDeflectionTableDisplay({ value, paperElevation }: Props) {
  return (
    <PropertyTable
      paperElevation={paperElevation}
      title="BC Maximum Deflections"
      columns={['Loading', 'Direction', 'Location', 'Deflection', 'L/d', 'L/d Limit']}
    >
      <MaxDeflectionEntryRow value={value.totalVerticalMaxDeflection} />
      <MaxDeflectionEntryRow value={value.liveVerticalMaxDeflection} />
      <MaxDeflectionEntryRow value={value.totalHorizontalMaxDeflection} />
    </PropertyTable>
  );
}
